<template>
  <div class="c-main-container">

    <div class="container">
      <div class="full">
        <h1 class="welcome">
          <img src="/images/kodomopay_logo.png" alt="こどもペイ">
        </h1>
        <div class="about-main">
          こども達の取り組みの見える化と<br>
          取り組みの意欲を高める!
        </div>

        <div class="describe-container">
          <v-touch v-on:swiperight="next" v-on:swipeleft="prev">
            <div class="describe-inner">
              <transition name="fade">
                <div v-show="describe === 0" class="describe-tr">
                  <div class="about">
                    お手伝いや勉強など<br>
                    約束を守ったらペイをあげよう！<br>
                    こども達がペイを貯めたら、<br>
                    ご褒美をあげよう！
                  </div>

                  <div class="kv-image-container">
                    <img src="/images/top-mv-kids.svg" alt="KIDS">
                  </div>
                </div>
              </transition>
              <transition name="fade">
                <div v-show="describe === 1" class="describe-image describe-tr">
                  <img src="/images/top_image_02.png" alt="使い方">
                </div>
              </transition>
              <transition name="fade">
                <div v-show="describe === 2" class="describe-image describe-tr">
                  <img src="/images/top_image_03.png" alt="キッズ専用ページ">
                </div>
              </transition>
            </div>
          </v-touch>
          <div class="describe-button-R" @click="next">
            <i class="fad fa-chevron-circle-right"></i>
          </div>
          <div class="describe-button-L" @click="prev">
            <i class="fad fa-chevron-circle-left"></i>
          </div>
          <div class="describe-position">
            <span :class="selectedDescribe(2)">・</span>
            <span :class="selectedDescribe(0)">・</span>
            <span :class="selectedDescribe(1)">・</span>
          </div>
        </div>

        <div class="menu">

          <div class="item">
            <UserLogin/>
          </div>

          <div class="hr-or">
            <div class="inner">
              <span>o r</span>
            </div>
          </div>

          <div class="item-left">
            <UserEntry/>
          </div>

        </div>
      </div>
    </div>

    <div class="how-to-use-container">
      <router-link :to="{name: 'HowToUse'}" class="how-to-use-button">使い方をみる</router-link>
    </div>

    <div class="news-container">
      <div class="header"><i class="fal fa-info-circle"></i> お知らせ</div>
      <div class="contents">
        <UserNews :isHeadline="true"/>
      </div>
    </div>

    <AdSense/>

    <div>
      <div class="image-container">
        <img src="/images/kodomopay.png">
      </div>
    </div>

    <div class="version">
      <versionText/>
    </div>

  </div>
</template>

<script>

import UserLogin from '@/components/user/UserLogin';
import UserEntry from '@/components/user/UserEntry';
import UserNews from '@/components/project/UserNews';
import AdSense from '@/components/project/AdSense';
import versionText from '@/__versionText';

export default {
  components: {
    UserLogin,
    UserEntry,
    UserNews,
    AdSense,
    versionText
  },
  data () {
    return {
      describe: 0,
      interval: null
    };
  },
  watch: {
    '$route' () {
      this.initialize();
    }
  },
  created: function () {
    this.initialize();
  },
  beforeDestroy: function () {

    console.log(this.interval);

    clearInterval(this.interval);

  },
  methods: {
    initialize: function () {

      this.setInterval();

    },
    setInterval: function () {

      clearInterval(this.interval);

      let _this = this;

      this.interval = setInterval(function () {
        _this.next();
        console.log('interval', _this.interval);
      }, 5000);

    },
    next: function () {
      if (this.describe === 2) {
        this.describe = 0;
      } else {
        this.describe++;
      }

      this.setInterval();

    },
    prev: function () {
      if (this.describe === 0) {
        this.describe = 2;
      } else {
        this.describe--;
      }

      this.setInterval();
    },
    selectedDescribe: function (target) {
      if (this.describe === target) {
        return 'select';
      } else {
        return 'default';
      }
    }
  }
};

</script>

<style lang="scss" scoped>

  @import '../../../assets/styles/_variable.scss';

  .menu {
    margin-top: 20px;
    font-size: 16px;

    .item-left,
    .item {
      padding-left: 20px;
      padding-right: 20px;
    }

    .hr-or {
      position: relative;
      border-bottom: 1px solid #ddd;
      margin: 20px auto;
      width: 300px;
      .inner {
        position: absolute;
        top: -10px;
        left: 0;
        right: 0;

        span {
          display: block;
          margin: 0 auto;
          background: #fff;
          width: 50px;
          text-align: center;
          font-weight: bold;
          color: #777;

        }
      }
    }

  }

  .describe-inner {
    position: relative;

    .describe-tr {
      position: absolute;
    }

  }

  .describe-position {
    width: 100%;
    bottom: 0;
    font-size: 40px;
    line-height: 12px;

    .default {
      color: #ddd;
    }
    .select {
      color: $keyColor;
    }
  }

  // 801以上
  @media screen and (min-width: 801px) {

    .container {
      text-align: center;

      .welcome {
        margin-top: 30px;
        font-size: 60px;
        text-shadow: 1px 1px 1px #999;
      }

      .about-main {
        margin-top: 10px;
        font-size: 16px;
        font-weight: bold;
        text-shadow: 1px 1px 1px #ddd;
      }

      .about {
        font-size: 14px;
        text-shadow: 1px 1px 1px #eee;
        line-height: 22px;
      }

    }

    .news-container {
      width: 700px;
      margin: 20px auto;
      border: 1px solid #ddd;
      border-radius: 6px;

      .header {
        padding: 8px 0 4px 8px;
      }

      .contents {
        margin: 0 20px;
        font-size: 14px;
      }
    }

    .image-container {
      width: 500px;
      margin: 10px auto;
      border: 1px solid #ddd;
      border-radius: 6px;
      padding: 20px;

      img {
        width: 100%;
      }
    }

    .describe-container {
      width: 320px;
      margin: 5px auto;
      position: relative;

      .describe-inner {
        height: 250px;
        display: flex;
        align-items: center;
      }

      .describe-button-R {
        position: absolute;
        font-size: 20px;
        top: 0;
        right: -70px;
        width: 100px;
        height: 250px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $keyColor;
      }

      .describe-button-L {
        position: absolute;
        font-size: 20px;
        top: 0;
        left: -70px;
        width: 100px;
        height: 250px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $keyColor;
      }

      .describe-image {
        img {
          width: 100%;
        }
      }

      .kv-image-container {
        margin-top: 15px;
        text-align: center;
      }
    }
  }

  // 800まで
  @media screen and (max-width: 800px) {

    .container {
      text-align: center;

      .welcome {
        font-size: 40px;
        text-shadow: 1px 1px 1px #999;
      }

      .about-main {
        margin-top: 10px;
        font-size: 16px;
        font-weight: bold;
        text-shadow: 1px 1px 1px #ddd;
      }

      .about {
        font-size: 14px;
        text-shadow: 1px 1px 1px #eee;
        line-height: 22px;
      }

    }

    .news-container {
      margin: 20px auto;
      border: 1px solid #ddd;
      border-radius: 6px;

      .header {
        padding: 8px 0 4px 8px;
      }

      .contents {
        margin: 0 20px;
        font-size: 14px;
      }
    }

    .image-container {
      margin: 10px auto;
      border: 1px solid #ddd;
      border-radius: 6px;
      padding: 20px;

      img {
        width: 100%;
      }
    }

    .describe-container {
      width: 100%;
      margin: 0 auto;
      position: relative;

      .describe-inner {
        height: 250px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .describe-button-R {
        position: absolute;
        font-size: 20px;
        top: 0;
        right: 0;
        width: 50px;
        height: 250px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: $keyColor;
      }

      .describe-button-L {
        position: absolute;
        font-size: 20px;
        top: 0;
        left: 0;
        width: 50px;
        height: 250px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: $keyColor;
      }

      .describe-image {
        img {
          width: 90%;
        }
      }

      .kv-image-container {
        margin-top: 10px;

        img {
          width: 80%;
        }
      }
    }

    .describe-position {
      position: absolute;
      bottom: 5px;
    }
  }

  .how-to-use-container {
    width: 300px;
    margin: 20px auto;
    text-align: center;
    border-top: 1px solid #ddd;
    padding-top: 30px;

    .how-to-use-button {
      display: inline-block;
      border: 1px solid $keyColor;
      color: $keyColor;
      width: 180px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-radius: 25px;
    }
  }

  .version {
    text-align: center;
    font-size: 12px;
    color: #aaa;
  }

  .fade-enter-active {
    animation: bounce-in .5s;
  }

  .fade-leave-active {
    animation: bounce-in .5s reverse;
  }

  @keyframes bounce-in {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

</style>
